import { Component, OnInit, OnDestroy } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import { Router } from '@angular/router';
import { MsalService, MsalBroadcastService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { filter, Subject, takeUntil } from 'rxjs';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
    private readonly _destroy = new Subject<void>();

    constructor(private primengConfig: PrimeNGConfig,
        private router: Router,
           private msalBroadcastService: MsalBroadcastService,
                   private msalService: MsalService,

    ) { }

    ngOnInit() {
        this.primengConfig.ripple = true;

        this.msalBroadcastService.inProgress$
    .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this._destroy)
    )
    .subscribe(() => {
        const adAttempt = localStorage.getItem('ad_attempt');
        if (adAttempt === 'true') {
            const accounts = this.msalService.instance.getAllAccounts();
            console.log(accounts,'accounts');
            // const currentUrl = this.router.url;
            
            // const isRootUrl = currentUrl === '' || currentUrl === '/' || currentUrl === '/#' || currentUrl === '#';
            // const isAuthRoute = currentUrl.includes('/auth/');
            // const isAppRoute = currentUrl.includes('/app') || currentUrl.includes('/user');
            
            if (accounts.length > 0) {
                this.router.navigate(['/auth/test-rout']);
                } else {
                    localStorage.removeItem('ad_attempt');
                    
                        this.router.navigate(['/auth/sign-in']);
                    
                }
        }
    });
    }
}
